module.exports = "/static/assets/c4223869e4bb0a1a956fba19c968cfa0.png";